export var SpendRuleErrorEnum;
(function (SpendRuleErrorEnum) {
    SpendRuleErrorEnum["DUPLICATED_RULES_UUID_IN_SPENDRULES_LIST"] = "DUPLICATED_RULES_UUID_IN_SPENDRULES_LIST";
    SpendRuleErrorEnum["MIN_AVAILABLE_POINTS_CHECK_FAIL"] = "MIN_AVAILABLE_POINTS_CHECK_FAIL";
    SpendRuleErrorEnum["NOT_ENOUGH_POINTS_TO_APPLY_ONE_TIME_FAIL"] = "NOT_ENOUGH_POINTS_TO_APPLY_ONE_TIME_FAIL";
    SpendRuleErrorEnum["NO_PROMOTION_UUID_IN_RULE_FAIL"] = "NO_PROMOTION_UUID_IN_RULE_FAIL";
    SpendRuleErrorEnum["NO_PROMOTION_OBJECT_FAIL"] = "NO_PROMOTION_OBJECT_FAIL";
    SpendRuleErrorEnum["NO_VALID_PROMOTION_OBJECT_FAIL"] = "NO_VALID_PROMOTION_OBJECT_FAIL";
    SpendRuleErrorEnum["STORE_NOT_IN_LOYALTY_PROGRAM"] = "STORE_NOT_IN_LOYALTY_PROGRAM";
    SpendRuleErrorEnum["USER_REPEATS_ZERO"] = "USER_REPEATS_ZERO";
    SpendRuleErrorEnum["NOT_ENOUGH_POINTS"] = "NOT_ENOUGH_POINTS";
    SpendRuleErrorEnum["LOW_CART_VALUE"] = "LOW_CART_VALUE";
    SpendRuleErrorEnum["TOO_MANY_REPEATS"] = "TOO_MANY_REPEATS";
    SpendRuleErrorEnum["PROMOTION_SIDE_NOT_VALID_ERROR"] = "PROMOTION_SIDE_NOT_VALID_ERROR";
    SpendRuleErrorEnum["PROMOTION_SIDE_NOT_APPLICABLE_ERROR"] = "PROMOTION_SIDE_NOT_APPLICABLE_ERROR";
})(SpendRuleErrorEnum || (SpendRuleErrorEnum = {}));
//# sourceMappingURL=SpendRuleErrorEnum.js.map